import { render, staticRenderFns } from "./userProfileView.vue?vue&type=template&id=938e8a08&scoped=true&"
import script from "./userProfileView.vue?vue&type=script&lang=js&"
export * from "./userProfileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938e8a08",
  null
  
)

export default component.exports